<!-- This component has no visible UI, it's used programmatically -->
@if (false) {
  <div class="pdf-generation-container">
    <!-- A container for PDF generation, hidden from view -->
  </div>
}

<!-- Loading overlay while generating PDF -->
@if (isGenerating) {
  <div class="pdf-generating-overlay">
    <div class="pdf-generating-container">
      <h3>Generating PDF...</h3>
      <div class="generation-message">Processing {{ lastGenerationAttempt?.length || 0 }} labels</div>
      <div class="progress-bar-container">
        <div [style.width.%]="generationProgress" class="progress-bar"></div>
      </div>
      <span>{{ generationProgress }}%</span>
    </div>
  </div>
}

<!-- Error message overlay -->
@if (generationError) {
  <div class="pdf-error-overlay">
    <div class="pdf-error-container">
      <h3>Error Generating PDF</h3>
      <p>{{ generationErrorMessage }}</p>
      <div class="error-buttons">
        <button (click)="retryGeneration()" class="retry-button" type="button">Retry</button>
        <button (click)="clearError()" class="close-button" type="button">Close</button>
      </div>
    </div>
  </div>
}

<!-- PDF Preview Overlay -->
@if (lastGeneratedPdfDataUri) {
  <div class="pdf-viewer-overlay">
    <div class="pdf-viewer-container">
      <div class="pdf-viewer-header">
        <h3>PDF Preview ({{ data.length }} {{ data.length === 1 ? 'Label' : 'Labels' }})</h3>
        <div class="pdf-viewer-controls">
          <button (click)="downloadPdf()" class="pdf-download-button" type="button">
            <i class="fas fa-download"></i> Download
          </button>
          <button (click)="closePdfPreview()" class="pdf-close-button" type="button">
            <i class="fas fa-times"></i> Close
          </button>
        </div>
      </div>
      <div class="iframe-container">
        <iframe [src]="getLastGeneratedPdfDataUri() | gallixSafeResourceUrl" frameborder="0"></iframe>
      </div>
    </div>
  </div>
}

<!-- Hidden container for barcode generation -->
<div class="barcode-container" id="barcodeContainer"></div>
